import { createContext, useContext } from 'react';

export type MenuMode = 'sidebar' | 'drawer';

export const MenuModeContext = createContext<MenuMode>('sidebar');

export function useMenuMode(): MenuMode {
  return useContext(MenuModeContext);
}
